/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Connector_AuthInputs */



/**
* | output |
* | --- |
* | "The connection to the source rejected our credentials, so this file could not be read. Check the connection's login details and retry." |
*
* @param {Embedding_Error_Connector_AuthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_connector_auth = /** @type {((inputs?: Embedding_Error_Connector_AuthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Connector_AuthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Verbindung zur Quelle hat unsere Zugangsdaten abgelehnt, daher konnte diese Datei nicht gelesen werden. Prüfen Sie die Zugangsdaten der Verbindung und versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("The connection to the source rejected our credentials, so this file could not be read. Check the connection's login details and retry.")
});